import CustomUserMenu from './custom-user-menu';
import { AppBar } from 'react-admin';
import { Typography } from '@material-ui/core';

const CustomAppBar = (props: any) => (
    <AppBar {...props} userMenu={<CustomUserMenu />} />
);

export default CustomAppBar;
